import { Modal, Box, Typography, Divider, Button } from '@mui/material';
import { ModalContainerStyled } from 'app';

type CopyRightModalProps = {
  open: boolean;
  handleCloseModal: () => void;
};

export const CopyRightModal = ({
  open,
  handleCloseModal,
}: CopyRightModalProps) => {
  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalContainerStyled>
        <Box display="flex" flexDirection="column" gap="20px" p="1rem">
          <Typography variant="body2">
            CPT © 2019 American Medical Association. All rights reserved.
          </Typography>
          <Typography variant="body2">
            Fee schedules, relative value units, conversion factors and/or
            related components are not assigned by the AMA, are not part of CPT,
            and the AMA is not recommending their use. The AMA does not directly
            or indirectly practice medicine or dispense medical services. The
            AMA assumes no liability for data contained or not contained herein.
          </Typography>
          <Typography variant="body2">
            CPT is a registered trademark of the American Medical Association.
          </Typography>
        </Box>

        <Divider />
        <Button
          variant="contained"
          sx={{ m: '12px', alignSelf: 'flex-end', width: '100px' }}
          onClick={handleCloseModal}
        >
          Close
        </Button>
      </ModalContainerStyled>
    </Modal>
  );
};
